'use strict';

/*
 Credit card payment class implementing Braintree payments.
*/
function BTCreditCardPayment() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_BTPayment];

  /* Set _BTPayment required dependencies */
  this.requiredBtDependencies = {
    client: true,
    'hosted-fields': true
  };

  // Form can be customized by overridding
  this._form = {
    selector: '#credit-card-form',
    styles: {
      input: {
        'font-size': '16px',
        'font-family': 'Verdana',
        height: '16px',
        'line-height': '16px'
      }
    },
    fields: {
      number: {
        selector: '#card-number'
      },
      expirationDate: {
        selector: '#expiration-date',
        placeholder: 'MM/YY'
      },
      cvv: {
        selector: '#cvv',
        placeholder: '3 or 4-digit verification number'
      },
      postalCode: {
        selector: '#postal-code',
        placeholder: 'A1A1A1',
        minlength: 6,
        maxlength: 6
      }
    }
  };

  this.initCreditCardPayment = function () {
    this.initBTPayment();
  };

  this.onLoadCreditCardPaymentError = function (error) {
    // .. credit card payment initialization error
  };

  this.onCreditCardPaymentReady = function () {
    // .. credit card form is ready
  };

  this.onCreditCardPaymentSubmit = function (evt) {
    // .. submit is clicked on credit card form
  };

  this.submitCreditCardPayment = function () {
    // Submit credit card payment to BT
    this._submitCreditCardPayment();
  };

  this.onSubmitCreditCardResponse = function (err, payload) {
    // .. response from BT after submitting credit card payment
  };

  this.onFieldsValidityChange = function (event) {
    // .. validity true/false of a field has changed
  };

  this.onFieldsFocus = function (event) {
    // .. field has gained focus
  };

  this.onFieldsBlur = function (event) {
    // ..field has lost focus
  };

  this.btReady = function () {
    this._createHostedFields();
  };

  this.btError = function (error) {
    this.onLoadCreditCardPaymentError({ type: 'NETWORK' });
  };

  this._createHostedFields = function () {
    braintree.hostedFields.create({
      client: this.btClient,
      styles: this._form.styles,
      fields: this._form.fields
    }, this._onCreateHostedFields.bind(this));
  };

  this._onCreateHostedFields = function (err, hostedFieldsInstance) {
    var _this = this;

    if (err) {
      this.onLoadCreditCardPaymentError(err);
      return;
    }

    this._hostedFieldsInstance = hostedFieldsInstance;

    // Setup form
    this._hostedFieldsInstance.on('inputSubmitRequest', function () {
      _this.onCreditCardPaymentSubmit();
    });
    this._hostedFieldsInstance.on('validityChange', this._onFieldsValidityChange.bind(this));
    this._hostedFieldsInstance.on('focus', this._onFieldsFocus.bind(this));
    this._hostedFieldsInstance.on('blur', this._onFieldsBlur.bind(this));
    this.node.querySelector(this._form.selector).addEventListener('submit', this.onCreditCardPaymentSubmit.bind(this));

    this.onCreditCardPaymentReady();
  };

  this._submitCreditCardPayment = function () {
    this._hostedFieldsInstance.tokenize(this.onSubmitCreditCardResponse);
  };

  this._onFieldsValidityChange = function (event) {
    var result = {};
    result[event.emittedBy] = event.fields[event.emittedBy];
    this.onFieldsValidityChange(result);
  };

  this._onFieldsFocus = function (event) {
    var result = {};
    result[event.emittedBy] = event.fields[event.emittedBy];
    this.onFieldsFocus(result);
  };

  this._onFieldsBlur = function (event) {
    var result = {};
    result[event.emittedBy] = event.fields[event.emittedBy];
    this.onFieldsBlur(result);
  };

  this.init = function () {};

  this.initAllReady = function () {};

  this.destroy = function () {};
}